import api from 'api'

export const createMetric = async (projectId, payload) => {
  const { data } = await api.post(`/project/${projectId}/metric`, payload)

  return data
}
